import * as Yup from 'yup'

import { isPhoneValue, isValidPhoneValue } from '@b-stock/fe-core/bstock-react'

Yup.addMethod(Yup.array, 'phone', function () {
  return this.test({ test: isValidPhoneValue, message: 'phone' })
})

Yup.addMethod(Yup.array, 'phoneRequired', function () {
  const message = 'required'

  return this.min(2, message).test({
    test: (value?: unknown[]) => {
      if (!value || !isPhoneValue(value)) {
        return false
      }

      // `isPhoneValue` above narrows `value`, so the `|| []` fallback is dead.
      // The first `country?.` is still needed under `noUncheckedIndexedAccess`;
      // the second isn't, since `country?.abbr` already narrowed it.
      const [country, natNum] = value
      return !!(country?.abbr && country.code && natNum)
    },
    message,
  })
})

declare module 'yup' {
  interface ArraySchema<
    // This needs to match Yup's own ArraySchema signature
    // oxlint-disable-next-line typescript-eslint/no-explicit-any
    TIn extends any[] | null | undefined,
    TContext,
    TDefault = undefined,
    TFlags extends Yup.Flags = '',
    T = unknown,
    C = unknown,
    TOut = unknown,
  > {
    phone(): Yup.ArraySchema<TIn, TContext, TDefault, TFlags, T, C, TOut>
    phoneRequired(): Yup.ArraySchema<
      TIn,
      TContext,
      TDefault,
      TFlags,
      T,
      C,
      TOut
    >
  }
}
